import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import * as idb from 'utils/shared/idbUrl';

interface ExpiredTokenProps {
  storePath: string;
}

const ExpiredToken: FC<ExpiredTokenProps> = ({ storePath }) => {
  const [t] = useTranslation();

  const onClickBack = () => {
    setTimeout(() => {
      const storedData = localStorage.getItem('latestPageUrl');
      let moduleKeys = storedData ? JSON.parse(storedData) : {};
      if (moduleKeys[storePath]) {
        moduleKeys[storePath].forEach((key: string) => {
          idb.deletePageState(key);
        });
        delete moduleKeys[storePath];
        localStorage.setItem('latestPageUrl', JSON.stringify(moduleKeys));
      }
    }, 300);
  };

  return (
    <div className="expired">
      <div className="title">{t('home.session_expired')}</div>
      <p className="expired-content">{t('home.session_expired_desc')}</p>
      <Link to={'/'} className="btn btn-primary" onClick={() => onClickBack()}>
        {t('home.go_back')}
      </Link>
    </div>
  );
};

export default ExpiredToken;
